import { authnPolicyType, authnPolicyTypeLabel } from 'client/Security/AuthNPolicyType';

const { application, userportal, ldap } = authnPolicyType;
const PolicyLabels = authnPolicyTypeLabel;

const AuthNPoliciesFilters = {
  userPortalType: () => ({
    displayValue: PolicyLabels[userportal],
    name: 'type',
    operator: 'eq',
    type: 'type',
    value: userportal,
  }),
  ssoApplicationType: () => ({
    displayValue: PolicyLabels[application],
    name: 'type',
    operator: 'eq',
    type: 'type',
    value: application,
  }),
  ldapType: () => ({
    displayValue: PolicyLabels[ldap],
    name: 'type',
    operator: 'eq',
    type: 'type',
    value: ldap,
  }),
};

export default AuthNPoliciesFilters;
